package diana.soleil.design.iraniancanadienbazzar.feature.home

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/**
 * Koin bindings for the Home feature. Explicit constructor call so `metroId` uses its default (the
 * `viewModelOf` reflection form would try to inject the nullable String). Aggregated by `:shared`.
 */
val homeModule = module {
    viewModel { HomeViewModel(get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get()) }
    viewModel { NotificationsViewModel(get()) }
    viewModel { (articleId: String) -> NewsDetailViewModel(get(), get(), articleId) }
    viewModel { NewsListViewModel(get(), get()) }
}
